import React, { forwardRef } from 'react';
import {
    MDBPopconfirm,
    MDBPopconfirmMessage
} from 'mdb-react-ui-kit';

const PopConfirm = forwardRef(({ isOpen, onConfirm, onClose, title}, ref) => {

    return (
        <MDBPopconfirm btnClassName="hide-popover-btn" modal open={isOpen} onConfirm={onConfirm} onClose={onClose} onCancel={onClose} >
            <MDBPopconfirmMessage>{title}</MDBPopconfirmMessage>
        </MDBPopconfirm>
    );
});


export default PopConfirm;
